import React, { useState } from "react";
import { Table, Collapse, Card  } from "antd";
import moment from "moment";
import Pageloader from "../../../../components/loader";
import {getRiderBatchLog} from "../../../../services/riders.service";
import { validationErrors } from "../../../../utils/Helpers";

const { Panel } = Collapse;
const pagename = "Batch Log";

const RiderBatchLog = (props) => {
  const [postData, setPostData] = useState(null);
  const [postDataPagi, setPostDataPagi] = useState(null);
  const [loading, setLoading] = useState(false);

  const postLists = async (page=1, limit=10) => {
    let dataFilter = {
      id: props?.RiderID,
      page: page,
      limit: limit,
    }
    try {
      setLoading(true);
      const {data} = await getRiderBatchLog(dataFilter);
      setPostData(data?.data);
      setPostDataPagi(data?.pagination)
    } catch (e) {
      validationErrors(e);
    } finally {
      setLoading(false);
    }
  };

  const paginationChange = async (page, limit) => {
    postLists(page, limit);
  };

  const postColumns = [
    {
      title: "Status",
      dataIndex: "type",
      render: (value) => (value || '-'),
    },
    {
      title: "Level",
      dataIndex: "batch_level",
      render: (value) => (value || '-'),
    },
    {
      title: "User",
      dataIndex: "user",
      render: (value) => {
        if (!value) return '-';
        return value.split('/')[0]; // Keep part before slash
      },
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      render: (value) => {
        return value ? <><span>{moment(value).format("DD MMMM, yyyy")}</span><p>{moment(value).format("h:mm A")}</p></> : '-';
      },
    },
  ];
  
  return (
    <Card title={pagename} bordered>
      <Collapse onChange={postData===null?()=>postLists(1,10):()=>{}}>
        <Panel header={pagename}>
          {loading ? <Pageloader/> : <Table
            dataSource={postData}
            columns={postColumns}
            // onRow={(r)=>({onDoubleClick:()=>window.open(`/overview/${r._id}`)})}
            pagination={{
              total: postDataPagi?.totalCount,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
              pageSize: postDataPagi?.limit,
              defaultCurrent: postDataPagi?.currentPage,
              pageSizeOptions: ["10", "20", "30", "40", "50"],
              showSizeChanger: true,
              onChange: (currentPage, pageSize) => {
                paginationChange(currentPage, pageSize);
              },
            }}
          />}
        </Panel>
        </Collapse>
    </Card>
  );
};

export default RiderBatchLog;
